/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentStatusEnum } from './appointmentStatusEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskAppointment { 
    readonly id: number;
    startDate: string;
    readonly appointmentTypeName: string;
    readonly isInitialConsultation: boolean;
    readonly appointmentStatus: AppointmentStatusEnum;
}
export namespace TaskAppointment {
}

export const TaskAppointment_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskAppointment_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskAppointment_appointmentTypeName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskAppointment_isInitialConsultation_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskAppointment_appointmentStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];


